import { Appointment } from 'components/_temp_ui_common/Appointments/types';
import axiosInstance from 'helpers/axiosInstance';

export const getAppointments = (
  memberId: string,
  params: getAppointmentsParams = {},
  requestType?: string,
) => {
  return axiosInstance
    .get<{ appointments: Appointment[] }>('/appointments', {
      params: {
        appointment: { member_id: memberId },
        ...params,
        request_type: requestType,
      },
    })
    .then(d =>
      d.data.appointments.filter(a => {
        if (a.async) return false;

        // no-show cancellations should still be visible to the member
        // any other cancellation should remain hidden
        if (a.status === 'cancelled' && a.cancellationReason) {
          const isNoShow =
            a.cancellationReason === 'cg_member_no_show' ||
            a.cancellationReason === 'cg_no_show';

          return isNoShow;
        }

        return true;
      }),
    );
};

export type getAppointmentsParams = {
  program?: 'core' | 'np' | 'iop';
};
